// src/pages/dashboard/wallet-detail/shared/WalletDetailLayout.tsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, CopyIcon } from '../../../../components/ui/Icons';
import { useWalletMetadata } from './use-wallet-metadata';
import { copyToClipboard, getBlockchainExplorerName, getBlockchainExplorerUrl } from './wallet-utils';
import '../../../../assets/styles/wallet-detail-button.css'; // Importamos los estilos de botones
import { useWindow } from '../../../../context/WindowContext';
import { CRYPTO_WALLETS } from "../../../../constants/wallets"
interface WalletDetailLayoutProps {
  token: string | undefined;
  address: string | undefined;
  balance: string | undefined;
  isLoading: boolean;
  // onRefresh: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function WalletDetailLayout({
  token,
  address,
  balance,
  isLoading,
  // onRefresh,
  children,
  actions
}: WalletDetailLayoutProps) {
  const navigate = useNavigate();
  const { getCurrencyIcon, getCurrencyName } = useWalletMetadata();
  const walletInfo = CRYPTO_WALLETS.filter(item =>{return item.token === token});
  const IconComponent = walletInfo[0].icon;
  const { windowWidth } = useWindow();
  // Estado local para mantener el balance mostrado y evitar que cambie de positivo a 0
  const [displayBalance, setDisplayBalance] = useState<string>(balance || '0');
  const lastPositiveBalance = useRef<string | null>(null);
  const isMobile = windowWidth <= 425;

  const headerStyles = isMobile
    ? 'flex flex-wrap items-center justify-between mb-7'
    : 'flex items-center justify-between mb-[30px]';

  const titleStyles = isMobile
    ? 'w-full text-3xl ml-2 mb-3'
    : 'text-[32px] ml-[10px]';

  const buttonContainerStyles = isMobile
    ? 'flex flex-wrap items-center justify-between w-full'
    : 'flex items-center  w-full';
  useEffect(() => {
    // Si recibimos un balance nuevo
    if (balance) {
      const newBalanceNum = parseFloat(balance);
      const currentBalanceNum = parseFloat(displayBalance);

      // Si el nuevo balance es positivo, siempre actualizamos
      if (newBalanceNum > 0) {
        setDisplayBalance(balance);
        lastPositiveBalance.current = balance;
        console.log(`Balance actualizado a valor positivo: ${balance}`);
      }
      // Si el nuevo balance es 0 pero teníamos un balance positivo, mantenemos el último valor positivo
      else if (newBalanceNum === 0 && currentBalanceNum > 0) {
        console.log(`PROTECCIÓN: Ignorando actualización de balance ${displayBalance} a 0`);
      }
      // Si el balance actual ya es 0 o no tenemos valor, podemos actualizar
      else if (currentBalanceNum === 0 || displayBalance === '0' || !displayBalance) {
        // Si tenemos un balance positivo guardado, usarlo en lugar de 0
        if (lastPositiveBalance.current) {
          console.log(`Recuperando último balance positivo conocido: ${lastPositiveBalance.current}`);
          setDisplayBalance(lastPositiveBalance.current);
        } else {
          setDisplayBalance(balance);
          console.log(`Balance actualizado a 0 (no había valor positivo previo)`);
        }
      }
    }
  }, [balance]);

  // Verificar si hay balance persistido en localStorage para esta dirección
  // useEffect(() => {
  //   if (address && currency === 'USDT_TRON') {
  //     try {
  //       const savedBalances = localStorage.getItem('tron-usdt-balances');
  //       if (savedBalances) {
  //         const parsed = JSON.parse(savedBalances);
  //         if (parsed[address] && parseFloat(parsed[address]) > 0) {
  //           console.log(`Encontrado balance persistido para ${address}: ${parsed[address]}`);

  //           // Si el balance actual es 0 o menor que el persistido, usar el persistido
  //           const currentBalanceNum = parseFloat(displayBalance);
  //           const persistedBalanceNum = parseFloat(parsed[address]);

  //           if (currentBalanceNum === 0 || persistedBalanceNum > currentBalanceNum) {
  //             console.log(`Usando balance persistido: ${parsed[address]}`);
  //             setDisplayBalance(parsed[address]);
  //             lastPositiveBalance.current = parsed[address];
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error al cargar balances persistidos:', error);
  //     }
  //   }
  // }, [address, currency]);

  return (
    <div className='sm:p-10 h-full'>
      {/* Header con botón de volver */}
      <div className={headerStyles}>
        <div className={buttonContainerStyles}>
          {!isMobile && (
            <button
              className="wallet-btn wallet-btn-sm"
              onClick={() => navigate('/dashboard/wallets')}
            >
              <ArrowLeftIcon size={18} style={{ marginRight: '5px' }} /> Back
            </button>
          )}
          <h1 className={titleStyles}>Wallet Details</h1>
          {isMobile && (
            <button
              className="wallet-btn wallet-btn-sm"
              onClick={() => navigate('/dashboard/wallets')}
            >
              <ArrowLeftIcon size={18} style={{ marginRight: '5px' }} /> Back
            </button>
          )}
          <button
            // onClick={onRefresh}
            className={`wallet-btn ${isMobile ? 'wallet-btn-sm' : 'wallet-btn-default ml-auto'}`}
            disabled={isLoading}
          >
            {isLoading ? 'Refreshing...' : 'Refresh Data'}
          </button>
        </div>
      </div>

      {/* Información principal de la wallet */}
     <div className="px-3 py-4 sm:!px-8 sm:!py-8 bg-white rounded-[10px] shadow-sm mb-8 relative">
        {/* Indicador de datos en caché */}
        {isLoading && (
          <div className='absolute top-[10px] right-[10px] px-2 py-1 bg-[#f8f9fa] rounded text-xs text-[#666666]'>
            Refreshing...
          </div>
        )}

        <div className='flex items-center sm:mb-5'>
          <div style={{ marginRight: '15px' }}>
            <IconComponent />
          </div>
          <div>
            {/* <h2 style={{ fontSize: '24px', fontWeight: 'bold' }}>{getCurrencyName(currency)}</h2> */}
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
              <p style={{
                fontSize: '14px',
                color: '#666',
                marginRight: '10px',
                wordBreak: 'break-all'
              }}>
                {address}
              </p>
              <button
                onClick={() => copyToClipboard(address)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '5px'
                }}
              >
                <CopyIcon size={16} color="#666" />
              </button>
            </div>
            <a
              href={getBlockchainExplorerUrl(token.toUpperCase(), address)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-belobaba-gold no-underline mt-1 inline-block"
            >
              View on {getBlockchainExplorerName(token.toUpperCase())}
            </a>
          </div>
        </div>

        <div className="flex justify-between items-center py-5 border-t border-b border-[#eee]">
          <div className='w-1/3 lsm:w-auto'>
            <p className='text-xl text-gray-500 text-center'>Available Balance</p>
            <h3 className="text-3xl font-bold text-belobaba-gold mt-1 text-center">
              {displayBalance} {walletInfo[0].currency}
            </h3>
          </div>

          <div className='flex flex-wrap gap-2 justify-end w-2/3 lsm:w-auto'>
            {actions}
          </div>
        </div>
      </div>

      {/* Contenido específico de cada wallet */}
      {children}
    </div>
  );
}